var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('p',{staticClass:"title"},[_vm._v("服务保障")]),_c('div',{staticClass:"service_box"},[_c('p',{staticClass:"img_box"},[_c('img',{attrs:{"src":_vm.utils.setOssUrl(_vm.picture),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }